export default {
  props: {
    maxlength: {
      description: 'String max length',
      type: Number,
      default: -1,
    },
  },
};
